import { render, staticRenderFns } from "./EventManager.vue?vue&type=template&id=bcb4a90e&scoped=true&"
import script from "./EventManager.vue?vue&type=script&lang=js&"
export * from "./EventManager.vue?vue&type=script&lang=js&"
import style0 from "./EventManager.vue?vue&type=style&index=0&id=bcb4a90e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-2f6a8101d6/2/home/apps/.yarn/berry/cache/vue-loader-npm-15.10.1-3a0b6c19d2-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb4a90e",
  null
  
)

export default component.exports